var orderstatuses = false;
$( document ).ready(function() {
	orderstatuses = new cOrderStatuses();
});

function cOrderStatuses(){
	var self = this;
	//Only run on /orderstatuses/ pages.
	if(window.location.href.indexOf("/orderstatuses") > -1) {
       this.onload();
   }
}

cOrderStatuses.prototype.onload = function(returnURL){


	$( "#sortable" ).sortable({
		placeholder: "ui-state-highlight",
		stop: function(event,ui){
			$('.list-order').each(function(k, v){
				v.value = k + 1;
			});
		}
	});
	$( "#sortable" ).disableSelection();


	$('.list-order').each(function(k, v){
		v.value = k + 1;
	});

	$('.os-delete').click(function(returnURL){
		if(!confirm('Are you sure you want to delete this order status? Any orders currently assigned this status will be hidden from reports.')){
			return;
		}
		id = $(this).data('id');
		csrf = $('[name="csrf-token"]').attr('content');
		$('<form action="/orderstatuses/' + id + '" method="post"><input name="_method" type="hidden" value="DELETE"><input name="_token" type="hidden" value="' + csrf + '"></form>').appendTo('body').submit();
	});
}
